/* global axios */
import ApiClient from '../ApiClient';

class PilotTools extends ApiClient {
  constructor() {
    super('pilot/assistants', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(`${this.url}/tools`, {
      params,
    });
  }
}

export default new PilotTools();
